export default {
  'cardholder.details.title': 'Personal Details',
  'cardholder.details.description': 'Please complete your personal details below',
  'cardholder.details.personal_data': 'Personal Data',
  'cardholder.details.card_embossing_line': 'Card Embossing Details',
  'cardholder.details.personal_data.salutation': 'Salutation',
  'cardholder.details.personal_data.first_name': 'First Name',
  'cardholder.details.personal_data.second_name': 'Second Name',
  'cardholder.details.personal_data.last_name': 'Last Name',
  'cardholder.details.personal_data.mother_maiden_name': "Mother's Maiden Name",
  'cardholder.details.personal_data.other_name': 'Are you known by any other name?',
  'cardholder.details.personal_data.nationality': 'Nationality',
  'cardholder.details.personal_data.dob': 'Date Of Birth',
  'cardholder.details.personal_data.documents': 'Documents',
  'cardholder.details.personal_data.emirates_id': 'Emirates ID Details',
  'cardholder.details.personal_data.passport': 'Passport Details',
  'cardholder.details.personal_data.emirates_id.document_number': 'Emirates ID Number',
  'cardholder.details.personal_data.emirates_id.expiry_date': 'Emirates ID Exp. Date',
  'cardholder.details.personal_data.passport.document_number': 'Passport Number',
  'cardholder.details.personal_data.passport.expiry_date': 'Passport Exp. Date',
  'cardholder.details.personal_data.visa': 'Visa Details',
  'cardholder.details.personal_data.visa.document_number': 'Document Number',
  'cardholder.details.personal_data.visa.expiry_date': 'Expiry Date',
  'cardholder.details.personal_data.phone': 'Mobile Number',
  'cardholder.details.personal_data.work_phone': 'Work Phone Number',
  'cardholder.details.personal_data.address': 'Address',
  'cardholder.details.personal_data.postal_address': 'Postal Address',
  'cardholder.details.personal_data.residential_address': 'Residential Address',
  'cardholder.details.personal_data.delivery_address': 'Delivery address',
  'cardholder.details.personal_data.address_line': 'Address Line',
  'cardholder.details.personal_data.po_box': 'P.O Box',
  'cardholder.details.personal_data.city': 'City',
  'cardholder.details.personal_data.country': 'Country',
  'cardholder.details.personal_data.emirate': 'Emirate',
  'cardholder.details.personal_data.residential_switch': 'Use Postal address as Residential address',
  'cardholder.details.personal_data.delivery_switch': 'Use Postal address as Delivery address',
  'cardholder.details.personal_data.option.yes': 'Yes',
  'cardholder.details.personal_data.option.no': 'No',
  'cardholder.details.personal_data.option.same_company_address': 'Use company address for card delivery',
  'cardholder.details.personal_data.option.another_address': 'Use another address',
  'cardholder.completion.welcome': 'Thank You!',
  'cardholder.completion.welcome.label1': 'Your card request has been completed successfully.',
  'cardholder.completion.welcome.label2':
    'If you wish to discuss any aspects of your services, please contact us via the details within your welcome kit email.',
  'cardholder.details.personal_data.po_box.error_min_5': 'PO Box must be at least 5',
  'cardholder.details.personal_data.po_box.error_digits': 'PO Box must be only digits',
  'cardholder.details.personal_data.dob.help': 'You must be at least 18 years old',
  'cardholder.details.personal_data.card_embossing_line_1': 'CardHolder Name - Line 1',
  'cardholder.details.personal_data.card_embossing_line_2': 'Company Name - Line 2',
  'cardholder.details.personal_data.card_embossing_line.validation': 'Max 21 characters and alphabets only',
};
